import React, {Component, Fragment} from 'react';
import {Link} from "react-router-dom";
import classnames from "classnames";
import {connect} from "react-redux";
import {actionGetAllPropertyList} from "../../../../actions/propertysAction";
import PropertyListCard from "../propertyListCard";
import defaultAgentAvatar from "../../../../assets/img/nophoto.png";
import DataNotFound from "../../../layout/DataNotFound";
import PropertyListCardLoader from "../propertyListCardLoader";
import {PROPERTIES} from "../../../../actions/types";
import Navbar from "../../navbar/Navbar";
import HeroSection from "../../HerroSection/hero-section";

class PrivatePropertyList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_lastData: false,
            q: '',
            offset: 0,
            limit: 15,
            type:'PUBLIC',
            isAdvanceFilter: false,
            errors: {},
        }
    }

    componentDidMount() {

        window.scrollTo(0, 0);
        document.title = "Properties | Prime Private Network";
        const request = {
            q: this.state.q,
            location: this.state.locations,
            offset: this.state.offset,
            limit: this.state.limit,
            category: '',
            user: this.props.auth.user._id,
            // type: "PRIVATE",
            type: this.state.type,
            status: "",
            bedRooms: "",
            bathRooms: "",
            furnishedStatus: "",
            transactionType: "",
            minPrice: "",
            maxPrice: "",
            searchError: '',
        };
        this.props.actionGetAllPropertyList(request, this.setLastData);
    }

    handleChange = e => {
        this.setState({[e.target.name]: e.target.value});
        if(this.state.q.length<=1){
            const request = {
                q: this.state.q,
                location: this.state.locations,
                offset: this.state.offset,
                limit: this.state.limit,
                category: '',
                user: this.props.auth.user._id,
                // type: "PRIVATE",
                type: this.state.type,
                status: "",
                bedRooms: "",
                bathRooms: "",
                furnishedStatus: "",
                transactionType: "",
                minPrice: "",
                maxPrice: "",
                searchError:'',
            };
            this.props.actionGetAllPropertyList(request);
        }

    }
    setLastData = (status) => {
        this.setState({is_lastData: status})
    };


    submitSearch =e=>{
        e.preventDefault();
        if(!this.state.q){
            this.setState({searchError:'search error'})
        }else {
            this.setState({searchError:''});
            const request = {
                q: this.state.q,
                location: this.state.locations,
                offset: this.state.offset,
                limit: this.state.limit,
                category: '',
                user: this.props.auth.user._id,
                // type: "PRIVATE",
                type: this.state.type,
                status: "",
                bedRooms: "",
                bathRooms: "",
                furnishedStatus: "",
                transactionType: "",
                minPrice: "",
                maxPrice: "",
                searchError:'',
            };
            this.props.actionGetAllPropertyList(request);

        }

    };
    onChangeType=e=>{
        const request = {
            q: this.state.q,
            location: this.state.locations,
            offset: this.state.offset,
            limit: this.state.limit,
            category: '',
            user: this.props.auth.user._id,
            type: e.target.value,
            status: "",
            bedRooms: "",
            bathRooms: "",
            furnishedStatus: "",
            transactionType: "",
            minPrice: "",
            maxPrice: "",
            searchError:'',
        };
        this.props.actionGetAllPropertyList(request);
    }

    render() {
        const {allProperties, PropertyCount,getAllPropertiesLoader} = this.props;
        return (
            <Fragment>
                <Navbar scenario={PROPERTIES}/>
                <HeroSection title="Private Properties"/>
                <div className="properties-list-section mt-5">
                    <div className="container bg-white">
                        <nav aria-label="breadcrumb">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">My Properties</li>
                            </ul>
                        </nav>
                        <div className="row justify-content-end pr-3">
                            <div className="form-group w-25 float-right">
                                <select className="form-control" id="exampleFormControlSelect1"  onChange={this.onChangeType}>
                                    <option value="PUBLIC">Public</option>
                                    <option value="PRIVATE">Private</option>
                                </select>
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div
                                className="col-lg-4 col-xl-4 col-md-4 col-12 order-lg-0 order-xl-0 order-md-0 order-1 ">
                                <p>{PropertyCount&&PropertyCount} Properties</p>
                            </div>
                            <div
                                className=" col-lg-8 col-xl-8 col-md-8 col-12 order-lg-1 order-xl-1 order-md-1 order-0 ">
                                <form onSubmit={this.submitSearch}>
                                    <label className="sr-only"
                                           htmlFor="inlineFormInputGroupUsername">Username</label>
                                    <div className="input-group">
                                        <input type="text"
                                               className={classnames(`form-control`, {
                                                   'is-invalid': this.state.searchError
                                               })}
                                               value={this.state.q}
                                               name="q" onChange={this.handleChange}
                                               placeholder="Search Properties"/>
                                        <div className="input-group-prepend">
                                            <button type="submit" className="btn search-btn input-group-text"><i
                                                className="fal fa-search"/>
                                            </button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="flex private">
                                {
                                    allProperties && allProperties.map((property, index) =>
                                        <PropertyListCard
                                            myPorperty={true}
                                            index={index}
                                            id={property._id}
                                            subcategory_name={property.subcategory ? property.subcategory.name : ''}
                                            property_img={property.image}
                                            agent_avatart={property.user.avatar ? property.user.avatar : defaultAgentAvatar}
                                            property_price={property.price}
                                            property_title={property.title}
                                            property_bedroom={property.bedroom}
                                            property_city_name={property.city.name}
                                            property_state_name={property.state.name}
                                            property_country_name={property.country.name}
                                            property_carpet_area={property.carpet_area}
                                            property_super_area={property.super_area}
                                            property_list_date={property.list_date}
                                            property_owner_name={property.owner_name}
                                            likes={property.likes}
                                            property_type={property.type}
                                        />
                                    )

                                }
                                {(allProperties.length < 1 && getAllPropertiesLoader) &&
                                <Fragment>
                                    <PropertyListCardLoader/>
                                    <PropertyListCardLoader/>
                                    <PropertyListCardLoader/>
                                    <PropertyListCardLoader/>
                                </Fragment>}


                            </div>
                        </div>
                        <div className="row justify-content-center">
                            {(!getAllPropertiesLoader && allProperties.length < 1) &&
                            <div className="text-center col-md-12"><DataNotFound
                                message={`Sorry! No any Property found.`}/></div>}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}


const mapStateToProps = (state) => ({
    auth: state.auth,
    profile: state.profile,
    allProperties: state.property.allProperties,
    PropertyCount: state.property.PropertyCount,
    getAllPropertiesLoader: state.property.getAllPropertiesLoader
});

export default connect(mapStateToProps, {actionGetAllPropertyList})(
    PrivatePropertyList
);


